import { render, staticRenderFns } from "./ColorCubeTest.vue?vue&type=template&id=6f28fdcb&scoped=true&"
import script from "./ColorCubeTest.vue?vue&type=script&lang=ts&"
export * from "./ColorCubeTest.vue?vue&type=script&lang=ts&"
import style0 from "./ColorCubeTest.vue?vue&type=style&index=0&id=6f28fdcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28fdcb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
